"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlEncode = exports.whichTransitionEvent = exports.whichAnimationEvent = exports.normalizeString = exports.normalizeAccent = exports.convertToKebabCase = exports.camelize = exports.externalLink = exports.replacehttp2https = exports.numberPrice2ClientStringPrice = exports.text2html = void 0;

var text2html = function text2html(text) {
  var htmlConverted = text.replace(/<b>/g, '<span class="bold">');
  htmlConverted = htmlConverted.replace(/<\/b>/g, '</span>');
  return {
    __html: htmlConverted
  };
};

exports.text2html = text2html;

var numberPrice2ClientStringPrice = function numberPrice2ClientStringPrice(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var decimalChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var thousandChar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var res = number;
  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);
  var splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  res = splitNum.join(decimalChar);
  return res;
};

exports.numberPrice2ClientStringPrice = numberPrice2ClientStringPrice;

var replacehttp2https = function replacehttp2https(input) {
  if (input) {
    return input.replace('http://', 'https://');
  }

  return null;
};

exports.replacehttp2https = replacehttp2https;

var externalLink = function externalLink(link) {
  return link.indexOf('http:') > -1 || link.indexOf('https:') > -1 || link.indexOf('mailto:') > -1;
};

exports.externalLink = externalLink;

var camelize = function camelize(str) {
  if (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }

  return null;
};

exports.camelize = camelize;

var convertToKebabCase = function convertToKebabCase(string) {
  if (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
  }

  return null;
};

exports.convertToKebabCase = convertToKebabCase;

var normalizeAccent = function normalizeAccent(str) {
  var strReturn = null;

  if (str) {
    strReturn = str;
    strReturn = strReturn.replace(/á/g, 'a');
    strReturn = strReturn.replace(/é/g, 'e');
    strReturn = strReturn.replace(/í/g, 'i');
    strReturn = strReturn.replace(/ó/g, 'o');
    strReturn = strReturn.replace(/ú/g, 'u');
  }

  return strReturn;
};

exports.normalizeAccent = normalizeAccent;

var normalizeString = function normalizeString(str) {
  var strReturn = null;

  if (str) {
    strReturn = str.toLowerCase();
    strReturn = normalizeAccent(strReturn);
    strReturn = strReturn.replace(/[^a-z]/g, '');
  }

  return strReturn;
};

exports.normalizeString = normalizeString;

var whichAnimationEvent = function whichAnimationEvent() {
  var el = document.createElement('fakeelement');
  var transitions = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd'
  };
  var transition = null;
  Object.keys(transitions).forEach(function (t) {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
};

exports.whichAnimationEvent = whichAnimationEvent;

var whichTransitionEvent = function whichTransitionEvent() {
  var el = document.createElement('fakeelement');
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };
  var transition = null;
  Object.keys(transitions).forEach(function (t) {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
};

exports.whichTransitionEvent = whichTransitionEvent;

var htmlEncode = function htmlEncode(s) {
  var el = document.createElement('div');
  var str = s;
  str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
  str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
  el.innerHTML = str;
  var returnString = el.textContent;
  return returnString;
};

exports.htmlEncode = htmlEncode;

//# sourceMappingURL=index.js.map